/* Built In Imports */
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/* Services */
import { Box, Flex, Heading } from '@chakra-ui/react';
import config from '@config';
import { getTicketList } from '@Services/eoeService';
import SeatingLayoutEightRow from '../components/Layout/SeatingLayoutEightRow';

/**
 *
 * @param {object} section
 * @returns ProgramDetailsEOE
 */
const ProgramDetailsMSR = ({ section, region, lang, pageData, setCityId }) => {
  // console.log('data',section);
  const sectionContent = section?.sectionContent;
  const matchPath = usePathname();
  const isEoeCombinedPage = matchPath.endsWith('attend-in-person');
  const [listTicket, setListTicket] = useState(null);

  useEffect(() => {
    dataTicket("8877");
  }, []);

  const dataTicket = async id => {
    try {
      if (sectionContent[1]?.data) {
        const res = sectionContent[1];
        setListTicket(res.data);
      }
      else {
        if (id && !isNaN(parseInt(id))) {
          const res = await getTicketList(id);
          setListTicket(res.data);
        }
      }
    } catch (error) {
      console.error('Err:', error);
    }
  };
  return (
    <Flex py={{ base: '40px', lg: '70px' }} px={{ base: '15px', lg: '140px' }}>
      <Box
        maxW="1140px"
        w="full"
        mx="auto"
        display={'flex'}
        justifyContent={'center'}
      >
        <Box
          // justifyContent={{ base: 'center', md: 'space-between' }}
          // flexFlow={{ base: 'column', md: 'row' }}
          alignItems="center"
        // gridGap={{ base: '20px', md: '70px', lg: '100px' }}
        >
          {/* <Flex
          flexFlow="row"
          alignItems={{ base: 'center', md: 'initial' }}
        > */}
          <Box mb={{ base: '10px', md: '' }} textAlign={'center'}>
            <img
              alt="divider"
              title="divider"
              src={`${config.imgPath}/d/46272/1664431985-drums-vector.png`}
            />
          </Box>
          <Heading
            as="h2"
            fontSize={{ base: '24px', md: '40px' }}
            color="#FFF7E9"
            pb={{ base: '20px', md: '50px' }}
            textAlign={'center'}
            fontFamily={"FedraSerifAStdBook"}
          >
            {section?.sectionContent?.[0].text}
          </Heading>
          <SeatingLayoutEightRow
            sectionContent={sectionContent}
            region={region}
            lang={lang}
            pageData={pageData}
            listTicket={listTicket}
          />
        </Box>
      </Box>
    </Flex>
  );
};
export default ProgramDetailsMSR;
